/**
 * Order-agnostic step events for the multi-step flows.
 *
 * The named step events (`gifting: submit greeting`, `signup: submit name`, ...)
 * are tied to *what* the user did, so when a flow is reordered those events swap
 * places inside an ordered Amplitude funnel and the treatment arm looks like it
 * collapsed. These events are keyed on `step_name` instead, so one funnel
 * definition reads correctly for every ordering.
 *
 * Fire these *alongside* the named events, never instead of them.
 */
import { logEvent, setAnalyticsUserProperties } from './analytics';
import { getAllVariants } from './experiments';

export const GIFTING_STEP_COMPLETED = 'gifting: complete step';
export const SIGNUP_STEP_COMPLETED = 'signup: complete step';

function logStepCompleted(eventName, { step_index, step_name, flow_variant, ...extra }) {
    logEvent(eventName, {
        step_index,
        step_name,
        flow_variant,
        ...extra,
    });
}

export function logGiftingStepCompleted({ step_index, step_name, flow_variant, ...extra }) {
    logStepCompleted(GIFTING_STEP_COMPLETED, { step_index, step_name, flow_variant, ...extra });
}

export function logSignupStepCompleted({ step_index, step_name, flow_variant, ...extra }) {
    logStepCompleted(SIGNUP_STEP_COMPLETED, { step_index, step_name, flow_variant, ...extra });
}

/** Stamp every experiment bucket onto the Amplitude user so any event can be cohorted. */
export function syncExperimentUserProperties() {
    setAnalyticsUserProperties(getAllVariants());
}
